/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";

export function SidebarLinks({ routes, unconfirmed = 0 }) {
  const location = useLocation();
  const activeRoute = (routeName) => location.pathname.includes(routeName);

  const navRoutes = routes.filter(
    (r) => r.layout === "/admin" && !r.secondary
  );

  return navRoutes.map((route, index) => (
    <Link key={index} to={route.layout + "/" + route.path}>
      <div className="relative mb-3 flex hover:cursor-pointer">
        <li className="my-[3px] flex w-full cursor-pointer items-center px-8">
          <span
            className={`${
              activeRoute(route.path)
                ? "font-bold text-brand-500 dark:text-white"
                : "font-medium text-gray-600"
            }`}
          >
            {route.icon ? route.icon : <DashIcon />}
          </span>
          <p
            className={`leading-1 ml-4 flex flex-1 ${
              activeRoute(route.path)
                ? "font-bold text-navy-700 dark:text-white"
                : "font-medium text-gray-600"
            }`}
          >
            {route.name}
          </p>
          {/* Unconfirmed badge on the orders route */}
          {route.path === "orders" && unconfirmed > 0 && (
            <span className="ml-2 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-500 px-1.5 text-[10px] font-bold text-white">
              {unconfirmed > 99 ? "99+" : unconfirmed}
            </span>
          )}
        </li>
        {activeRoute(route.path) && (
          <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
        )}
      </div>
    </Link>
  ));
}

export default SidebarLinks;
